import type { InputHTMLAttributes, JSX, TextareaHTMLAttributes } from 'react'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  required?: boolean
}

export function Input({
  label,
  error,
  required,
  className = '',
  id,
  ...props
}: InputProps): JSX.Element {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')
  const inputClass = ['fui-input', error ? 'fui-input-error' : '', className]
    .filter(Boolean)
    .join(' ')

  return (
    <div>
      {label && (
        <label htmlFor={inputId} className={`fui-label ${required ? 'fui-label-required' : ''}`}>
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={inputClass}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...props}
      />
      {error && (
        <p id={`${inputId}-error`} className="fui-error" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  error?: string
  required?: boolean
}

export function Textarea({
  label,
  error,
  required,
  className = '',
  id,
  ...props
}: TextareaProps): JSX.Element {
  const inputId = id ?? label?.toLowerCase().replace(/\s+/g, '-')
  const inputClass = ['fui-input', 'fui-textarea', error ? 'fui-input-error' : '', className]
    .filter(Boolean)
    .join(' ')

  return (
    <div>
      {label && (
        <label htmlFor={inputId} className={`fui-label ${required ? 'fui-label-required' : ''}`}>
          {label}
        </label>
      )}
      <textarea
        id={inputId}
        className={inputClass}
        aria-invalid={error ? 'true' : undefined}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...props}
      />
      {error && (
        <p id={`${inputId}-error`} className="fui-error" role="alert">
          {error}
        </p>
      )}
    </div>
  )
}
